export interface IEnum {
  value: string
  label: string
}

export const createEnum = (input: string[] | Record<string, string>, transform?: (value: string) => string): IEnum[] =>
  (Array.isArray(input) ? input : Object.values(input)).map((item) => ({
    value: item,
    label: transform ? transform(item) : item,
  }))
